import { createFileRoute } from '@tanstack/react-router'
import { GlossaryPage, glossaryHead } from '@/components/glossary-page'

const data = {
  term: 'Escalation Policy',
  slug: 'escalation-policy',
  definition: `An escalation policy defines the rules for who gets notified about an incident and in what order. If the first responder does not acknowledge an alert within a set time, the alert escalates to the next person or team.

A typical escalation policy has multiple levels. Level 1 might be the on-call engineer, level 2 the team lead, and level 3 the engineering manager. Each level has a timeout before the alert moves up.

Escalation policies ensure that no alert falls through the cracks. Even if the primary on-call is unavailable — whether asleep, in a meeting, or dealing with another incident — someone else will be notified.`,
  whyItMatters: `Without escalation policies, unacknowledged alerts just sit there. The on-call engineer might be sick, their phone might be on silent, or they might already be working a different incident. Escalation ensures a human always sees the alert.

Escalation policies also provide accountability. When an incident goes to level 3, it signals to leadership that something serious is happening and may need additional resources.`,
  howUptrackHelps: `Uptrack lets you configure multiple alert channels per monitor. You can set up primary alerts via Slack and secondary alerts via email, ensuring critical notifications reach the right people through multiple paths.

Combined with Uptrack's confirmation checks, your escalation chain only activates for real incidents, preserving the urgency and trust in the escalation process.`,
  relatedTerms: [
    { name: 'On-Call', href: '/glossary/on-call' },
    { name: 'Alert Fatigue', href: '/glossary/alert-fatigue' },
    { name: 'Incident Management', href: '/glossary/incident-management' },
    { name: 'MTTR', href: '/glossary/mttr' },
  ],
}

export const Route = createFileRoute('/_site/glossary/escalation-policy')({
  component: () => <GlossaryPage data={data} />,
  head: () => glossaryHead(data),
})
